<template>
  <base-dialog
    @save-item="saveItem"
    dialogId="create-nas-dialog"
    :open.sync="openDialog"
    :form-ref.sync="nasFormRef"
    :loading.sync="isLoading"
  >
    <template v-slot:[`dialog.title`]>
      <span>Créer un NAS</span>
    </template>
    <template v-slot:[`dialog.content`]>
      <v-container>
        <nas-form
          :nas-form.sync="nasForm"
          :rules="rules"
          :nas-identifier="true"
        ></nas-form>
      </v-container>
    </template>
    <template v-slot:[`dialog.actions.save`]>Créer</template>
  </base-dialog>
</template>
<script>
import { toRefs, computed } from "@vue/composition-api";
import NasForm from "@/components/Nas/NasForm";
import { useNas } from "@/composables/nas";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    NasForm,
    BaseDialog,
  },
  props: {
    clientPortal: Object,
    partner: Object,
    open: Boolean,
  },

  setup(props, { emit }) {
    /* Import des API */
    const { nasData, createNas } = useNas();

    /* Cycle de vie */

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const saveItem = async function () {
      await createNas(props.clientPortal.id);
      openDialog.value = nasData.createNasDialog;
    };

    /* Watchers */

    return {
      ...toRefs(nasData),
      openDialog,
      saveItem,
    };
  },
};
</script>
